import { Breadcrumbs, Container, PageOverviewBanner } from '@/components';
import { ContentTypeName } from '@/constants';
import type { Asset, SectionThemeKey } from '@/interfaces';
import { capitalize } from '@/utils';
import SectionListRenderer from '../SectionListRenderer';
import { LeftSection, SectionListWrapper } from '../SectionListRenderer.styles';
import HeaderSection from '../common/HeaderSection/HeaderSection';

interface ICompanyPageRendererProps {
  sectionList?: any[];
  title?: string;
  subTitle?: string;
  icon?: Asset;
  breadcrumbsTheme?: SectionThemeKey;
}

const FULL_WIDTH_SECTION_LIST: ContentTypeName[] = [];

const CompanyPageRenderer: React.FC<ICompanyPageRendererProps> = ({
  sectionList = [],
  title = '',
  subTitle = '',
  icon,
  breadcrumbsTheme,
}) => {
  const foundPageOverviewBanner = sectionList.find(
    (section: any) => capitalize(section.__typename) === ContentTypeName.PageOverviewBanner,
  );

  const sections = sectionList.reduce<{
    fullWidthSectionList: any[];
    leftSectionList: any[];
  }>(
    (result, section) => {
      const contentType = capitalize(section.__typename) as ContentTypeName;
      const isIncludedPageOverViewBanner = contentType === ContentTypeName.PageOverviewBanner;
      if (isIncludedPageOverViewBanner) {
        return result;
      }

      const isFullWidthSection = FULL_WIDTH_SECTION_LIST.includes(contentType);

      if (isFullWidthSection) {
        result.fullWidthSectionList.push(section);
      } else {
        result.leftSectionList.push(section);
      }

      return result;
    },
    {
      fullWidthSectionList: [],
      leftSectionList: [],
    },
  );

  return (
    <>
      {foundPageOverviewBanner && (
        <PageOverviewBanner
          priority
          breadcrumbs={{
            title,
            breadcrumbsTheme,
          }}
          {...foundPageOverviewBanner}
        />
      )}
      <Container>
        <SectionListWrapper>
          <LeftSection>
            {!foundPageOverviewBanner && <Breadcrumbs title={title} breadcrumbsTheme={breadcrumbsTheme} />}
            <HeaderSection title={title} icon={icon} description={subTitle} />
            <SectionListRenderer sectionList={sections.leftSectionList} />
          </LeftSection>
        </SectionListWrapper>
      </Container>

      <SectionListRenderer sectionList={sections.fullWidthSectionList} />
    </>
  );
};

export default CompanyPageRenderer;
